import _ from 'lodash'
import { LICENSE_TYPES } from '@/components/pages/activate/license-types'
import { LICENSE_STATUS_ICON } from '@/components/pages/activate/license-status-icon'

export default {
  name: 'table-column-text',
  props: {
    license: {
      type: Object,
      default: {}
    },
    stylingClasses: {
      type: Array,
      default: []
    }
  },
  computed: {
    isLicenseLocked () {
      return !_.isEmpty(this.license) && this.license.status === LICENSE_STATUS_ICON.LOCKED
    },
    isLicenseOk () {
      return !_.isEmpty(this.license) && this.license.status === LICENSE_STATUS_ICON.OK
    },
    isWidgetLicenseType () {
      return !_.isEmpty(this.license) && this.license.type === LICENSE_TYPES.WIDGETS
    },
    isKioskLicenseType () {
      return !_.isEmpty(this.license) && this.license.type === LICENSE_TYPES.KIOSK
    },
    isSystemsLicenseType () {
      return !_.isEmpty(this.license) && this.license.type === LICENSE_TYPES.SYSTEMS
    }
  },
  data () {
    return {}
  }
}
